/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select a specific confirmed order
 * @param {any} state The state management `state`
 * @returns {OrderEntity | null} The `confirmed order` that has been selected from the store
 */
const orderConfirmedSelector = createSelector(ordersSelector, (orders) => orders.orderConfirmed);

export default orderConfirmedSelector;
